import { createSlice } from "@reduxjs/toolkit";
import { fetchFinanceTaskStatus } from "../documentUploadApi";

const fetchFinanceTaskStatusSlice = createSlice({
    name: "financeTaskStatus",
    initialState: {
        status: null,
        data: null,
        loading: false,
        error: null,
    },
    reducers: {
        resetFinanceTaskStatus: (state) => {
            state.status = null;
            state.data = null;
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchFinanceTaskStatus.pending, (state) => {
                state.loading = true;
                state.status = "loading";
            })
            .addCase(fetchFinanceTaskStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.status = "succeeded";
                state.data = action.payload;
            })
            .addCase(fetchFinanceTaskStatus.rejected, (state, action) => {
                state.loading = false;
                state.status = "failed";
                state.error = action.payload;
            });
    },
});

export const { resetFinanceTaskStatus } = fetchFinanceTaskStatusSlice.actions;
export default fetchFinanceTaskStatusSlice.reducer;

